import request from '@/utils/request';

export async function queryDashboard(params) {
  return request('/dashboard', {
    params,
  });
}
